module.exports = __webpack_public_path__ + "img/api.76676846.svg";